import { Box, Card, CardContent, Divider, Grid, Table, TableBody, TableCell, TableContainer, TableRow, Typography } from "@mui/material";
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppMisc } from '../../../misc/appMisc';
import { AppUtils } from '../../../utils/appUtils';
import { GENDER_OPTIONS } from '../../../utils/constants';
import styles from "./style";
import { getHealthClientAndPalikaInfoData } from "../../../action/HealthClientInfo";
import HealthServiceCardHeader from "../../../pages/users/components/health-service-card-header/HealthServiceCardHeader";

const ReferredOutSlip = ({ patientData }) => {
  const classes = styles();
  const healthClientInfo = useSelector(state => state.healthClientInfo);
  const dispatch = useDispatch();

  useEffect(() => {
    !healthClientInfo && dispatch(getHealthClientAndPalikaInfoData());
  }, [healthClientInfo])

  return (
    <>
      <Card>
        <CardContent>
          <Box margin={2}>
            <HealthServiceCardHeader healthPostName={healthClientInfo?.name} municipality={healthClientInfo?.palikaName} district={healthClientInfo?.district && AppMisc.getDistrictName(healthClientInfo.district)} />
            <Typography variant="h6" align="center" gutterBottom>
              (फिर्ता जानकारी पाउने सम्बन्धमा भरिने जानकारी पत्र)
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} className={classes.container}>
                <Typography>मिति: ........... / ........... / ...........</Typography>
                <Typography>फिर्ता जानकारी पठाउने संस्था श्री: {healthClientInfo?.name}</Typography>
              </Grid>
            </Grid>
            <Divider className={classes.divider} />
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography>सेवाग्राहीको नाम, थर: {patientData?.patientFirstName || "-"} {patientData.patientLastName || "-"}</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography>लिङ्ग: {patientData?.gender ? AppMisc.findLabelFromValue(GENDER_OPTIONS, patientData.gender) : "-"}</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography>उमेर: {patientData?.age ? AppUtils.replaceWithNepaliDigit(patientData.age) + " " + AppMisc.getAgeUnitLabel(patientData.ageUnit) : "-"}</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography>जिल्ला: {patientData?.district ? AppMisc.getDistrictName(patientData?.district) : "-"}</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography>गा.वि.स./न.पा.: {patientData?.palikaName ? AppMisc.getMunicipalityName(patientData?.palikaName) : "-"}</Typography>
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                सम्पर्क नं.: {patientData?.phoneNumber ? AppUtils.replaceWithNepaliDigit(patientData.phoneNumber) : "-"}
              </Grid>
            </Grid>
            <Divider className={classes.divider} />
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography>सम्पर्क गर्नुपर्ने मिति: ........... / ........... / ...........</Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography>दिइएको सेवा: ................................................................................</Typography>
              </Grid>
            </Grid>
            <Divider className={classes.divider} />
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography>फिर्ता जानकारी दिनेको नाम: .....................................................</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography>पद: ...........</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography>सही: ...........</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography>मिति: ........... / ........... / ...........</Typography>
              </Grid>
            </Grid>
            <Divider className={classes.divider} />
            <Typography variant="subtitle1" gutterBottom>
              फिर्ता जानकारी दिने संस्थाको नाम:
            </Typography>
            <TableContainer>
              <Table size="small">
                <TableBody>
                  <TableRow>
                    <TableCell>ठेगाना:</TableCell>
                    <TableCell>जिल्ला:</TableCell>
                    <TableCell>गा.वि.स./न.पा.:</TableCell>
                    <TableCell>वडा नं.:</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>...............</TableCell>
                    <TableCell>...............</TableCell>
                    <TableCell>...............</TableCell>
                    <TableCell>...............</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </CardContent>
      </Card>
    </>
  )
}
export default ReferredOutSlip;